export const PREMIUM_GET = "premium/get";
